import React from "react";
import styled from "@emotion/styled";
import LikeButton from "@components/button/LikeButton";
import { useParams } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const Container = styled.div<{ url: string }>(({ theme, url }) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  height: "245px",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "3.2rem 2rem",
  color: theme.color.white,
  backgroundColor: theme.color.black,
  backgroundImage: `url(${url})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",

  ".korean_name": {
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
    fontWeight: theme.fontWeight.bold,
  },
  ".en_name": {
    fontSize: "2.8rem",
    lineHeight: "2.8rem",
    fontWeight: theme.fontWeight.light,
  },
  ".desc": {
    color: theme.color.light_gray,
    fontSize: "1.2rem",
    lineHeight: "2rem",
    fontWeight: theme.fontWeight.regular,
    paddingTop: "0.4rem",
  },
}));

const LikeButtonWrapper = styled.div({
  position: "absolute",
  top: "2.8rem",
  right: "2rem",
  zIndex: 10,
});

const BrandInfoCard = () => {
  const lang = window.localStorage.getItem("language");
  const en = lang === "en";
  const { brandId } = useParams();
  const { getBrandDetail } = useApiRequest();

  const { data: brandDetail } = useQuery({
    queryKey: ["brandDetail", brandId],
    queryFn: () => getBrandDetail(Number(brandId)),
  });

  return (
    <Container url={brandDetail?.thumbnail_url}>
      <span className="korean_name">{brandDetail?.brand_name_ko}</span>
      <span className="en_name">{brandDetail?.brand_name_en}</span>
      <span className="desc">
        {en ? brandDetail?.introduction_en : brandDetail?.introduction_ko}
      </span>

      <LikeButtonWrapper>
        <LikeButton
          white
          isLiked={brandDetail?.is_liked === 1}
          id={Number(brandId)}
          type="brand"
        />
      </LikeButtonWrapper>
    </Container>
  );
};

export default BrandInfoCard;
